import { CartButton as CartButtonBase } from "@omni/components/components/Navigation/Buttons/CartButton/cartButton";
import { CartButtonProps } from "@omni/types/components/props/cartButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { CartButtonComponent } from "@/components/Navigation/Buttons/CartButton/cartButton.component";

export const CartButton = ({
    // HeaderButton props
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover,
    alerts,

    // CartButton props
    redirect
}: CartButtonProps<BaseStore.Etna>) => {
    return (
        <CartButtonBase
            text={text}
            ariaLabel={ariaLabel}
            hiddenText={hiddenText}
            icon={icon}
            link={link}
            invert={invert}
            invertMobile={invertMobile}
            showMenuOnHover={showMenuOnHover}
            alerts={alerts}
            redirect={redirect}
        >
            <CartButtonComponent />
        </CartButtonBase>
    );
};
